import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images, externalLinks } from '../data/mock';
import { Quote, Star, ExternalLink } from 'lucide-react';

const Testimonials = () => {
  const { language } = useLanguage();

  const testimonials = [
    {
      quoteKr: '강남 한복판에서 이런 루프탑 공간이 있다니! 불멍하면서 친구들과 힐링했어요.',
      quoteEn: 'Amazing rooftop space right in Gangnam! Had a great healing time with friends by the fire.',
      authorKr: '네이버 블로그 후기',
      authorEn: 'Naver Blog Review',
      image: images.rooftopBalcony,
      url: 'https://blog.naver.com/rabblt0701/224141985288'
    },
    {
      quoteKr: '아이들 생일파티로 단독 대관했는데 정말 만족스러웠어요. 다음에 또 올게요!',
      quoteEn: 'Rented the whole place for kids birthday - absolutely satisfied! Will come back!',
      authorKr: '네이버 블로그 후기',
      authorEn: 'Naver Blog Review',
      image: images.rooftopNight,
      url: 'https://blog.naver.com/woolru/224112143268'
    },
    {
      quoteKr: '회사 회식으로 방문했는데 프라이빗한 공간에서 눈치 안보고 즐길 수 있어서 좋았어요.',
      quoteEn: 'Visited for company dinner - loved the private space where we could enjoy freely.',
      authorKr: '네이버 블로그 후기',
      authorEn: 'Naver Blog Review',
      image: images.indoor,
      url: 'https://blog.naver.com/bongking52/224077949280'
    }
  ];

  return (
    <section className="bg-[#121212] py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
            {language === 'ko' ? '고객 후기' : 'Customer Reviews'}
          </h2>
          <div className="flex items-center justify-center gap-2">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} fill="currentColor" />
              ))}
            </div>
            <span className="text-white/60">
              {language === 'ko' ? '네이버 평점 5.0' : 'Naver Rating 5.0'}
            </span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <a
              key={index}
              href={testimonial.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-black border border-white/10 hover:border-[#00FFD1]/50 transition-all duration-300 overflow-hidden"
            >
              {/* Image */}
              <div className="relative h-40 overflow-hidden">
                <img 
                  src={testimonial.image} 
                  alt="Review"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <Quote className="absolute bottom-3 left-3 text-[#00FFD1]" size={24} />
              </div>
              
              {/* Content */}
              <div className="p-5">
                <p className="text-white/90 text-base leading-relaxed mb-4 line-clamp-3">
                  "{language === 'ko' ? testimonial.quoteKr : testimonial.quoteEn}"
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-white/50 text-sm">
                    {language === 'ko' ? testimonial.authorKr : testimonial.authorEn}
                  </span>
                  <span className="text-[#00FFD1] text-sm flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    {language === 'ko' ? '전체 보기' : 'Read more'}
                    <ExternalLink size={12} />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-8">
          <a
            href={externalLinks.naverPlace}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#00FFD1] hover:underline"
          >
            {language === 'ko' ? '네이버 플레이스에서 모든 후기 보기' : 'View all reviews on Naver Place'}
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;